"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
// This section has no widgets, but the generated code imports this file, so it needs to exist.
};
